import React from 'react'
import { useLocation } from 'react-router-dom'
import { useCustomer } from 'lib/core/hooks'
import { Header } from 'components/Layout/components/Header'
import { CustomerResults } from '../CustomerResults'
import { Footer } from './components/Footer'

interface Props {
  children: JSX.Element
}

export const Layout = ({ children }: Props) => {
  const { isLoggedIn } = useCustomer()
  const { pathname } = useLocation()
  const isCartOrCheckout = pathname === '/cart' || pathname.includes('/checkout')

  return (
    <>
      <Header />
      <div>
        {children}
      </div>
      {isLoggedIn && !isCartOrCheckout && (
        <CustomerResults />
      )}
      <Footer />
    </>
  )
}
